import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {LoadedFile} from "../../pit-shared/domain/loaded-file";
import {HttpHeaders} from "@angular/common/http";
import {DxHttpDispatcher} from "../../dx-core/services/dx-http-dispatcher.service";
import {fromPromise} from "rxjs/internal-compatibility";
import {BdpkConfigService} from "./bdpk-config.service";
import {DxObjectMapper} from "../../dx-core/services/dx-object-mapper.service";
import {BdpkApiInfo} from "../domain/bdpk-api-info";
import {DxRequestOptions} from "../../dx-core/domain/http/dx-request-options";
import {map, take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BdpkFileService {

  private options: DxRequestOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
    observe: 'response',
    withCredentials: true
  };

  constructor(private _configService: BdpkConfigService,
              private _mapper: DxObjectMapper,
              private _http: DxHttpDispatcher) {
  }

  uploadFile(blob:Blob, fileName: string): Observable<LoadedFile> {
    const promise = new Promise<any>((resolve, reject) => {
      const path = this._configService.bdpkFileStorageService + '/files';
      const headers = new HttpHeaders();
      let formData: FormData = new FormData();
      formData.append('file', blob, fileName);

      this._http
        .post(path, formData, {headers: headers, observe: 'response'})
        .subscribe(response => {
          resolve(this._mapper.deserialize(response.body, LoadedFile));
        }, errorResponse => {
          reject(DxHttpDispatcher.handleHttpError(errorResponse));
        });
    });
    return fromPromise<any>(promise);
  }

  downloadFile(id: number): void {
    const path = this._configService.bdpkFileStorageService + '/files/' + id;
    window.location.href = path;
  }

  /**
   * метод, который нужен только для определения git commit всего backend-а.
   */
  info(): Observable<BdpkApiInfo> {
    return this._http
      .get(this._configService.bdpkFileStorageService + '/info', this.options)
      .pipe(
        take(1),
        map(response => {
          return this._mapper.deserialize(response.body, BdpkApiInfo);
        }));
  }
}
